import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import { DEFAULT_MAX_WAPPR_HOISTING_NUM } from '@/modules/workPermits/consts'
import { save } from '@/utils/xfs'
import { getDataViaCache } from '../helper'

const PREFIX_PATH = '/work_permits'

export async function createWorkPermit (payload) {
  try {
    const response = await HTTP.post(PREFIX_PATH, payload)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function getAllWorkPermits (query, isSilentGet = false) {
  try {
    let response
    if (isSilentGet) {
      response = await HTTP.silentGet(PREFIX_PATH, { params: query })
    } else {
      response = await HTTP.get(PREFIX_PATH, { params: query })
    }
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function getAllWorkPermitsInProject (projectId, query, isSilentGet = false) {
  try {
    let response
    if (isSilentGet) {
      response = await HTTP.silentGet(`${PREFIX_PATH}/project/${projectId}`, { params: query })
    } else {
      response = await HTTP.get(`${PREFIX_PATH}/project/${projectId}`, { params: query })
    }
    return response.data.data
  } catch (err) {
    notification.handleResponseAlert(err.response)
    return []
  }
}

export async function getDashBoardWorkPermits (query) {
  try {
    let response
    response = await HTTP.get(`${PREFIX_PATH}/dashboard`, { params: query })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function extendWorkPermit (id, extendDate) {
  try {
    const response = await HTTP.put(`${PREFIX_PATH}/extend/${id}`, { extendDate })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function requestExtendWorkPermit (id, requestExtendDate) {
  try {
    const reponse = await HTTP.patch(`${PREFIX_PATH}/${id}/request-extension`, { requestExtendDate })
    return reponse.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function rejectExtensionWorkPermit (id, requestBody) {
  try {
    const reponse = await HTTP.patch(`${PREFIX_PATH}/${id}/rejct-extension`, requestBody)
    return reponse.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getWorkPermitById (id, query) {
  try {
    const response = await HTTP.get(`${PREFIX_PATH}/${id}`, { params: query })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function isHoistingExceedMaxNum (request) {
  try {
    const response = await HTTP.get(`${PREFIX_PATH}/isHoistingExceedMaxNum/${request.contractorId}`, {params: request})
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function updateWorkPermitById (id, request, action) {
  try {
    const response = await HTTP.put(`${PREFIX_PATH}/${id}`, request, { headers: { 'X-CMS-Action': action } })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function updateHoistingById (id, request) {
  try {
    const response = await HTTP.put(`${PREFIX_PATH}/${id}/hoisting`, request)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function changeWorkPermitStatus (id, request) {
  try {
    const response = await HTTP.patch(`${PREFIX_PATH}/${id}`, request)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'workPermit')
    return null
  }
}

export async function updateWorkerInfoBySourceId (sourceId, request) {
  try {
    const response = await HTTP.put(`/workers/${sourceId}`, request)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function updateWorkPermitManager (sourceId, request) {
  try {
    const response = await HTTP.patch(`${PREFIX_PATH}/${sourceId}/updateManager`, request)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function deleteWorkPermit (id) {
  try {
    const response = await HTTP.delete(`${PREFIX_PATH}/${id}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function getMaxWAPPRHoistingNum () {
  try {
    const response = await HTTP.get('/settings/maxWAPPRHoistingNum')
    return parseInt(response.data.data.value) || DEFAULT_MAX_WAPPR_HOISTING_NUM
  } catch (err) {
    return DEFAULT_MAX_WAPPR_HOISTING_NUM
  }
}

export async function getWPConflictStatus (id, extendTime = 0) {
  try {
    const response = await HTTP.get(`${PREFIX_PATH}/${id}/conflictStatus/${extendTime}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getWpList (query, payload = {}) {
  const { pageNumber = 500 } = payload
  const result = await getDataViaCache(PREFIX_PATH, query, { pageNumber })
  return result
}

export async function getTPProjectPermit (projectId) {
  try {
    const response = await HTTP.silentGet(`${PREFIX_PATH}/tenant-project/${projectId}/project-permit`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function exportWorker (query) {
  try {
    const response = await HTTP.get(`${PREFIX_PATH}/export-worker`, { params: query, responseType: 'arraybuffer' })
    save(response)
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function exportWorkPermits (query) {
  try {
    const response = await HTTP.post(`${PREFIX_PATH}/export-work-permits`, query, { responseType: 'arraybuffer' })
    save(response)
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}
